import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import FormContainer from '../../../components/CommonComponents/FormContainer'
import LeftWrapper from '../../../components/CommonComponents/LeftWrapper'
import Wrapper from '../../../components/CommonComponents/Wrapper'
import AdminSaveHeader from '../../../components/CommonComponents/AdminSaveHeader'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Defaultloadinggif from '../../../layout/Others/Defaultloadinggif'
import { toast } from 'react-toastify'
import axios from "axios";
import { getItemToken } from '../../../Utils/localStorageUtils'
import MessageLabel from '../../../components/CommonComponents/MessageLabel'
import MessageSubHeading from '../../../components/CommonComponents/MessageSubHeading'
import AdminCustomInput from '../../../components/CommonComponents/AdminCustomInput'
import MessageHeading from '../../../components/CommonComponents/MessageHeading'
import { slugGenerator } from '../../../components/CommonMethod/CommonMethods'
import AdminCustomArea from '../../../components/CommonComponents/AdminCustomArea'
import JoditEditor from 'jodit-react'
import AdminCustomSelect from '../../../components/CommonComponents/AdminCustomSelect'
import Select from "react-select";
import { useMyContext } from '../../../components/Provider/CommonProvider'
import MessageBox from '../../../components/CommonComponents/MessageBox'
import { TagsInput } from "react-tag-input-component";
import RightWrapper from '../../../components/CommonComponents/RightWrapper'
import AdminSwitch from '../../../components/CommonComponents/AdminSwitch'
import AdminImageUploadZone from '../../../components/CommonComponents/AdminImageUploadZone'
import useCompressImageConfig from '../../../components/CommonApis/Compressimageapi'
import usePpvGlobalImageConfig from '../../../components/CommonApis/ppv_global_change'
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton'
import AdminCustomRadio from '../../../components/CommonComponents/AdminCustomRadio'
import Response_Processing from '../../../layout/Others/Response_Processing'
import { IoClose } from 'react-icons/io5'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import NoRecordTable from '../../../components/CommonComponents/NoRecordTable'
import AdminResponseZone from '../../../components/CommonComponents/AdminResponseZone'
import { IconDeleteFigma, IconDeleteSolid, IconEditFigma, IconListFigma, IconSolidEdit } from '../../../Assets/MyIcons'
import AdminDeleteModal from '../../../components/CommonComponents/AdminDeleteModal'
import AdminBackNavigation from '../../../components/CommonComponents/AdminBackNavigation'
import { FaEllipsisVertical } from 'react-icons/fa6'
import AdminCheckBox from '../../../components/CommonComponents/AdminCheckBox'
import { IoMdInformationCircle } from 'react-icons/io'
import AdminAIModal from '../../../components/CommonComponents/AdminAImodal'
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from '../../../CustomFields/saveCustomFieldsStrict'
import PushNotificationSettings from '../../../components/CommonComponents/PushNotificationSettings';
import LanguageAddUpdate from "../../Language/Manage_Language/LanguageAddUpdate";
import ArtistAddUpdate from "../../Audio/Artist_Management/ArtistAddUpdate";
import SeriesGenreAddUpdate from "./SeriesGenreAddUpdate";
import { MdAddCircle } from "react-icons/md";

const SeriesAddUpdate = () => {
    const siteTheme = useSelector(state => state.siteTheme.siteTheme)
    const onlyPermission = useSelector(state => state.userPermission.onlyPermission)
    const baseURL = process.env.REACT_APP_Baseurl
    const labelSource = 'add-series'
    const headers = getItemToken('access_token')
    const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`
    const createApi = `${baseURL}/admin/series/create`
    const storeApi = `${baseURL}/admin/series/store`
    const seoApi = `${baseURL}/admin/series/seo/update`
    const editApi = `${baseURL}/admin/series/edit`
    const updateApi = `${baseURL}/admin/series/update`
    const updatePPV = `${baseURL}/admin/series/payperviewprice/update`
    const SeriesSeasonFind = `${baseURL}/admin/series/season/unique`
    const seasonOrderApi = `${baseURL}/admin/series/season/order`
    const seasonEditApi = `${baseURL}/admin/series/season/edit`
    const seasonStore = `${baseURL}/admin/series/season/store`
    const seasonUpdate = `${baseURL}/admin/series/season/update`
    const seasonImageApi = `${baseURL}/admin/series/season/image-upload`
    const seasonDeleteApi = `${baseURL}/admin/series/season/multi-delete`
    const seasonUpdatePPV = `${baseURL}/admin/series/season/payperviewprice/update`

    const navigate = useNavigate()

    const { fetchRequest, buildDynamicSubText, validateOrientationBySlug, validateImageRatio, globalImageUplaodAPI, imageValidationAPI } = useMyContext()
    const imageApi = globalImageUplaodAPI()
    const imageValidationApi = imageValidationAPI()
    const { compressResolutionFormat } = useCompressImageConfig();
    const { allCurrencylistfromappi, globalPpvStatusActive } = usePpvGlobalImageConfig();
    const [imagerequiredValidation, setImagerequiredValidation] = useState(null)
    const generateAISuggestionApi = `${baseURL}/admin/ai-prompt-response`
    const [modalTarget, setModalTarget] = useState(null);
    const [defaultPrompt, setDefaultPrompt] = useState("");
    const [showModal, setShowModal] = useState(false);


    const { id } = useParams()
    const combinedRef = useRef({
        title: null,
        slug: null
    });

    const [labelDisplay, setLabelDisplay] = useState([]);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        selected_categories: [],
        active: 1,
        global_ppv: 0,
        response_status: false,
        response_error: "",
        response_status_code: '',
        response_loading: true,
        year: new Date().getFullYear(),
        ppv_price: "",
        ios_ppv_price: "",
        // Ideabiz purchase plan (series-level)
        ideabiz_purchase_plans_id: null,
        google_product_id_ppvs_id: null,
        push_notification_enabled: 0,
        push_notification_title: "",
        push_notification_description: "",
        push_notification_image: "",
        push_notification_publish_type: "publish_now",
        push_notification_publish_time: "",
        push_notification_source_type: 3,
        push_notification_source_type_name: "Series",
        push_notification_slug: "",
        is_ads: 0,
        banner: 0,
        slider_image: "",
        Slider_Thumbnail: "",
        is_shorts: 0,
    })
    const [formDataError, setFormDataError] = useState({})
    const [defaultOption, setDefaultOption] = useState({})
    const [coverImageFile, setCoverImageFile] = useState(null);
    const [playerImageFile, setPlayerImageFile] = useState(null);
    const [tvImageFile, setTvImageFile] = useState(null);
    const [sliderImageFile, setSliderImageFile] = useState(null);
    const [notificationImageFile, setNotificationImageFile] = useState(null);
    const [seasonImageFile, setSeasonImageFile] = useState(null);
    const [showOverlay, setShowOverlay] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [withOutRefreshSeason, setWithOutRefreshSeason] = useState(false)
    const [pricemodel, setPriceModel] = useState('');
    const [seasonPriceModel, setSeasonPriceModel] = useState('');
    const [getGeofencingAvailableCountries, setGetGeoFencingAvailableCountries] = useState(null);
    const [getGeofencing, setGetGeoFencing] = useState(null);

    const [seasonModal, setSeasonModal] = useState(false)
    const [convertPrice, setConvertPrice] = useState({
        source_type: 3,
        source_id: "",
        PPVType: "",
        PriceType: "",
        ActualPrice: "",
        IOSPrice: "",
        convertedPriceRates: []
    })
    const [seasonConvertPrice, setSeasonConvertPrice] = useState({
        source_type: 6,
        source_id: "",
        PPVType: "",
        PriceType: "",
        ActualPrice: "",
        IOSPrice: "",
        convertedPriceRates: []
    })
    const [season, setSeason] = useState({ status: false, loading: true, error: "", data: "" })
    // const [customFieldValuesSeason, setCustomFieldValuesSeason] = useState({}); // Removed custom fields
    const [customFieldValuesSeason, setCustomFieldValuesSeason] = useState({});
    const [customFieldValues, setCustomFieldValues] = useState({});
    // Season-level data including Ideabiz purchase plan (raw ID)
    const [seasonData, setSeasonData] = useState({ loading: false, error: "", ideabiz_purchase_plans_id: null, google_product_id_ppvs_id: null })
    const [modelClose, setModelClose] = useState(false);
    const [itemToDelete, setItemToDelete] = useState({});
    // action 

    // Inline create modals
    const [languageModal, setLanguageModal] = useState(false);
    const [artistModal, setArtistModal] = useState(false);
    const [categoryModal, setCategoryModal] = useState(false);
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 1895 + 2 }, (_, index) => ({ name: 1895 + index, value: 1895 + index }));

    const assignDefault = (value, defaultValue = 0) => value ? value : defaultValue;
    const closeModal = () => {
        setModelClose((prev) => !prev);
    };
    const closeAIModal = () => {
        setShowModal(false);
    };
    const handleSeasonInput = async (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'text' || type == "time" || type == "date" || type == "number") {
            setSeasonData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [`season_${name}`]: '',
            }));
        }
        if (type === 'select-one') {
            setSeasonData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [`season_${name}`]: '',
            }));
        }
    }

    const handleInput = async (e) => {
        const { name, value, type, checked } = e.target;
        if (type === "checkbox") {
            if (name === "banner") {
                setFormData((prev) => ({
                    ...prev,
                    [name]: checked ? 1 : 0,
                }));
                setFormDataError((prev) => ({
                    ...prev,
                    episode_trailer: "",
                }));
                return;
            }
            if (name === "global_ppv") {
                const price = checked ? defaultOption?.globalOption : formData?.ppv_price;

                setFormData((prev) => ({
                    ...prev,
                    ppv_price: price,
                }));

                setFormDataError((prev) => ({
                    ...prev,
                    ppv_price: "",
                }));

                if (globalPpvStatusActive?.PPV_Individual_Contents === 1) {
                    await handleCovertPrice(price);
                }

                return;
            }
            setFormData((prev) => ({
                ...prev,
                [name]: checked ? 1 : 0,
            }));
        }
        if (type === 'text' || type == "time" || type == "date" || type == "datetime-local") {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
            if (name == "title") {
                setFormDataError((prev) => ({
                    ...prev,
                    ['slug']: '',
                }));
            }
        }
        if (type === "number") {
            setFormData((prev) => ({
                ...prev,
                [name]: value.replace(/[^0-9.]/g, '')
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }
        if (type === 'select-one') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }
        if (type === "textarea") {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

    }
    const handleBlurtitle = () => {
        if (!formData?.slug) {
            generateSlug(formData?.title);
        }
    };

    const generateSlug = (title) => {
        const slug = slugGenerator(title)
        setFormData((prev) => ({
            ...prev,
            'slug': slug,
        }));
    };

    const handleInputKeyDowntitle = (event) => {
        if (event.key === "Enter" || event.key === "Tab") {
            if (!formData?.slug) {
                generateSlug(formData?.name);
            }
        }
    };
    const handleBlurTitleEdit = () => {
        generateSlug(formData?.slug);
    };

    const handleTrailerSelect = (id) => {
        setFormData((prev) => {
            const currentTrailers = prev?.episode_trailer || [];
            const updatedTrailers = currentTrailers.includes(id)
                ? currentTrailers.filter(item => item !== id)
                : [...currentTrailers, id];
            return {
                ...prev,
                episode_trailer: updatedTrailers
            };
        });
        setFormDataError((prev) => ({
            ...prev,
            'episode_trailer': '',
        }));
    };


    const multiSelectLabel = (array, valueKey, labelKey) => {
        return Array.isArray(array) ? array?.map((item) => ({
            value: item[valueKey],
            label: item[labelKey]
        })) : [];
    };

    const handleMultiSelect = (selectedOptions, actionMeta) => {
        setFormData((prev) => ({
            ...prev,
            [actionMeta.name]: selectedOptions
        }))
        setFormDataError((prev) => ({
            ...prev,
            [actionMeta.name]: ""
        }))
    }
    const handleTagsChange = (newTags) => {
        const cleanedTags = (newTags || [])
            .flatMap((tag) => String(tag ?? "").split(","))
            .map((tag) => tag.trim().toLowerCase())
            .filter((tag) => tag !== "")
            .filter((value, index, self) => self.indexOf(value) === index);
        setFormData((prevFormData) => ({
            ...prevFormData,
            search_tag: cleanedTags,
        }));
    };

    const handleFileChange = async (event) => {
        const { files, name, value, accept, dataset } = event.target
        setFormDataError((prev) => ({
            ...prev,
            [name]: "",
        }));
        setFormData((prev) => ({
            ...prev,
            [name]: ""
        }))

        if (files?.length > 0) {
            const newFile = files[0];
            const reader = new FileReader();
            const readFile = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (error) => reject(error);
                    reader.readAsDataURL(file);
                });
            };
            const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];

            if (!allowedTypes.includes(files[0]?.type)) {
                setFormDataError((prev) => ({
                    ...prev,
                    [name]: "Only JPG, JPEG, WEBP and PNG files are allowed.",
                }));
                return;
            }
            const fileContent = await readFile(newFile);

            // Dynamic orientation validation first if provided by input
            if (dataset?.orientation && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                const result = await validateOrientationBySlug(newFile, dataset.orientation);
                if (!result.ok) {
                    let msg = 'Selected image does not match the required orientation.';
                    if (result?.expected) {
                        const ratio = result?.ratio || `${result.expected.width}:${result.expected.height}`;
                        msg = `Image must be in ${ratio} Ratio or ${result.expected.width}x${result.expected.height}px`;
                    }
                    setFormDataError((prev) => ({ ...prev, [name]: msg }));
                    if (name === 'image') setCoverImageFile(null);
                    if (name === 'player_image') setPlayerImageFile(null);
                    if (name === 'tv_image') setTvImageFile(null);
                    if (name === 'season_image') setSeasonImageFile(null);
                    if (name === 'notification_image') setNotificationImageFile(null);
                    combinedRef.current[name]?.focus?.();
                    return;
                }
            }

            const checkSize = compressResolutionFormat?.series === 1

            if (name === 'notification_image') {
                setNotificationImageFile(newFile);
                setFormData((prev) => ({
                    ...prev,
                    [name]: newFile
                }))
                if (checkSize && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                    const isValidSize = await validateImageRatio(newFile, 2 / 1, 1024, 512);
                    if (!isValidSize) {
                        setFormDataError((prev) => ({
                            ...prev,
                            [name]: "Image must be in 2:1 Ratio or 1024x512px",
                        }));
                    }
                }
            }

            const isValidSizeVertical = await validateImageRatio(newFile, 2 / 3, 1080, 1620);
            const isValidSizeHorizontal = await validateImageRatio(newFile, 16 / 9, 1280, 720);

            if (name == 'image') {
                setCoverImageFile(newFile);
                setFormData((prev) => ({
                    ...prev,
                    [name]: newFile
                }))
                if (!dataset?.orientation && !isValidSizeVertical && checkSize && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Image must be in 2:3 Ratio or 1080x1620px.",
                    }));
                }
            }
            if (name == 'player_image') {
                setPlayerImageFile(newFile);
                setFormData((prev) => ({
                    ...prev,
                    [name]: newFile
                }))
                if (!dataset?.orientation && !isValidSizeHorizontal && checkSize && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Image must be in 16:9 Ratio or 1280x720px.",
                    }));
                }
            }
            if (name == 'tv_image') {
                setTvImageFile(newFile);
                setFormData((prev) => ({
                    ...prev,
                    [name]: newFile
                }))
                if (!dataset?.orientation && !isValidSizeHorizontal && checkSize && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Image must be in 16:9 Ratio or 1280x720px.",
                    }));
                }
            }
            if (name == 'season_image') {
                setSeasonImageFile(newFile);
                setSeasonData((prev) => ({
                    ...prev,
                    ['image']: newFile
                }))
                if (!dataset?.orientation && !isValidSizeHorizontal && checkSize && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Image must be in 16:9 Ratio or 1280x720px.",
                    }));
                }
            }
            if (name === 'slider_image') {
                setSliderImageFile(newFile);
                setFormData((prev) => ({
                    ...prev,
                    [name]: newFile
                }))
                const isValidSizeSlider = await validateImageRatio(newFile, 8 / 3, 3840, 1440);
                if (!dataset?.orientation && !isValidSizeSlider && checkSize && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Image must be in 8:3 Ratio or 3840x1440px.",
                    }));
                }
            }
        }
    };

    const getDefaultCurrencySetting = () => {
        const dc = defaultOption?.defaultCurrency;
        if (Array.isArray(dc)) return dc?.[0] || {};
        return dc || {};
    }

    const handleCovertPrice = async (value) => {
        let formIsValid = true
        if (!value) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                ppv_price: "ppv price cannot be empty.",
            }));
            combinedRef.current['ppv_price'].focus()
            formIsValid = false;
        }
        if (formIsValid) {
            const selectedCountryCode = defaultOption?.defaultCurrency?.code
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_Curreny_generate}/${selectedCountryCode}`);
                const rates = response.data.rates;
                let convertedPrices = allCurrencylistfromappi?.map(item => {
                    let country_name = item?.country;
                    let Symbol = item?.Symbol || item?.symbol;
                    let Code = item?.code;

                    const matchingCountry = allCurrencylistfromappi.find(currency => currency.code === item?.code);
                    if (matchingCountry) {
                        country_name = matchingCountry?.country;
                        Symbol = matchingCountry?.Symbol || matchingCountry?.symbol;
                    }

                    return {
                        Code: Code,
                        Country: country_name,
                        Symbol: Symbol,
                        ConvertedPriceRate: (value * (rates[item?.code] || 0)).toFixed(2),
                        price: value,
                        RateDifference: ((value * (rates[item?.code] || 0)) - value).toFixed(2),
                        editPrice: (value * (rates[item?.code] || 0)).toFixed(2),
                        ChangedPrice: (value * (rates[item?.code] || 0)).toFixed(2),
                        isEditable: true,
                    };
                });

                const cfg = getDefaultCurrencySetting();
                if (cfg?.same_country_toggle == 1 && cfg?.same_currency_country) {
                    const targetCountryName = cfg?.same_currency_country;
                    convertedPrices = convertedPrices.filter(item => 
                        String(item.Code).toUpperCase() === String(cfg?.code).toUpperCase() || 
                        String(item?.Country).toLowerCase() === String(targetCountryName).toLowerCase()
                    );
                } else if (cfg?.enable_secondary_currency == 1 && cfg?.enable_multi_currency != 1) {
                    const rawSec = cfg?.secondary_currencies;
                    const secCur = (rawSec ? (typeof rawSec === 'string' ? JSON.parse(rawSec) : rawSec) : []) || [];
                    const secondaryCodes = secCur.map(c => String(typeof c === 'object' ? (c.short_code || c.value || c.code) : c).toUpperCase());
                    convertedPrices = convertedPrices.filter(item => item?.Code && secondaryCodes.includes(String(item.Code).toUpperCase()));
                }

                setConvertPrice(prevState => ({
                    ...prevState,
                    source_type: 3,
                    source_id: id,
                    PPVType: formData?.global_ppv,
                    PriceType: selectedCountryCode,
                    ActualPrice: value,
                    IOSPrice: formData?.ios_ppv_price,
                    convertedPriceRates: convertedPrices
                }));
            } catch (error) {
                console.error('Error fetching currency conversion rates:', error);
            }
        }
    };
    const handleSeasonCovertPrice = async (value) => {
        let formIsValid = true
        if (!value) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                season_ppv_price: "ppv price cannot be empty.",
            }));
            combinedRef.current['season_ppv_price'].focus()
            formIsValid = false;
        }
        if (formIsValid) {
            const selectedCountryCode = defaultOption?.defaultCurrency?.code
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_Curreny_generate}/${selectedCountryCode}`);
                const rates = response.data.rates;
                let convertedPrices = allCurrencylistfromappi?.map(item => {
                    let country_name = item?.country;
                    let Symbol = item?.Symbol || item?.symbol;
                    let Code = item?.code;

                    const matchingCountry = allCurrencylistfromappi.find(currency => currency.code === item?.code);
                    if (matchingCountry) {
                        country_name = matchingCountry?.country;
                        Symbol = matchingCountry?.Symbol || matchingCountry?.symbol;
                    }

                    return {
                        Code: Code,
                        Country: country_name,
                        Symbol: Symbol,
                        ConvertedPriceRate: (value * (rates[item?.code] || 0)).toFixed(2),
                        price: value,
                        RateDifference: ((value * (rates[item?.code] || 0)) - value).toFixed(2),
                        editPrice: (value * (rates[item?.code] || 0)).toFixed(2),
                        ChangedPrice: (value * (rates[item?.code] || 0)).toFixed(2),
                        isEditable: true,
                    };
                });

                const cfg = getDefaultCurrencySetting();
                if (cfg?.same_country_toggle == 1 && cfg?.same_currency_country) {
                    const targetCountryName = cfg?.same_currency_country;
                    convertedPrices = convertedPrices.filter(item => 
                        String(item.Code).toUpperCase() === String(cfg?.code).toUpperCase() || 
                        String(item?.Country).toLowerCase() === String(targetCountryName).toLowerCase()
                    );
                } else if (cfg?.enable_secondary_currency == 1 && cfg?.enable_multi_currency != 1) {
                    const rawSec = cfg?.secondary_currencies;
                    const secCur = (rawSec ? (typeof rawSec === 'string' ? JSON.parse(rawSec) : rawSec) : []) || [];
                    const secondaryCodes = secCur.map(c => String(typeof c === 'object' ? (c.short_code || c.value || c.code) : c).toUpperCase());
                    convertedPrices = convertedPrices.filter(item => item?.Code && secondaryCodes.includes(String(item.Code).toUpperCase()));
                }

                setSeasonConvertPrice(prevState => ({
                    ...prevState,
                    PPVType: seasonData?.global_ppv,
                    PriceType: selectedCountryCode,
                    ActualPrice: value,
                    IOSPrice: seasonData?.ios_ppv_price,
                    convertedPriceRates: convertedPrices
                }));
            } catch (error) {
                console.error('Error fetching currency conversion rates:', error);
            }
        }
    };

    const handleClearSelectFile = (value) => {
        if (value == 'image') {
            setCoverImageFile(null)
        }
        if (value == 'tv_image') {
            setTvImageFile(null)
        }
        if (value == 'player_image') {
            setPlayerImageFile(null)
        }
        if (value == 'season_image') {
            setSeasonImageFile(null)
        }
        if (value == 'notification_image') {
            setNotificationImageFile(null)
        }
        if (value == 'slider_image') {
            setSliderImageFile(null)
        }
        setFormDataError((prev) => ({
            ...prev,
            [value]: ""
        }))

    }

    const handlePriceModal = () => {
        setPriceModel((prev) => !prev)
    }
    const handleSeasonPriceModal = () => {
        setSeasonPriceModel((prev) => !prev)
    }
    const handlePriceModalClose = async (status) => {
        const actualStatus = typeof status === 'string' ? status : null;
        setFormData((prev) => ({
            ...prev,
            ppv_price: formData?.ppv_price,
            ios_ppv_price: formData?.ios_ppv_price,
            global_ppv: formData?.global_ppv,
            individualPPVTrigger: actualStatus
        }))
        setPriceModel(false)
    }
    const handleSeasonPriceModalClose = async (status) => {
        const actualStatus = typeof status === 'string' ? status : null;
        setSeasonData((prev) => ({
            ...prev,
            ppv_price: seasonData?.ppv_price,
            ios_ppv_price: seasonData?.ios_ppv_price,
            global_ppv: seasonData?.global_ppv,
            individualPPVTrigger: actualStatus
        }))
        await handleSeasonPriceModal()
    }
    const handleseasonModal = () => {
        setSeasonModal((prev) => !prev)
        setSeasonData(null)
        setSeasonImageFile(null); // clear selected image
        setFormDataError((prev) => ({
            ...prev,
            season_image: null,                  // clear validation error
        }));
    }

    useEffect(async () => {
        const ImageValidationresponse = await fetchRequest({
            method: 'GET',
            url: imageValidationApi,
            params: {},
            data: {},
        })
        setImagerequiredValidation(ImageValidationresponse?.Compress_image)
    }, [])

    // api action
    const formValidation = () => {
        let formIsValid = true;
        if (!formData?.title) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                title: "Title cannot be empty.",
            }));
            combinedRef.current['title'].focus()
            formIsValid = false;
        }
        if (!formData?.slug) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                slug: "Slug cannot be empty.",
            }));
            combinedRef.current['slug'].focus()
            formIsValid = false;
        }

        if (!formData?.access) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                access: "Choose the access.",
            }));
            combinedRef.current['access'].focus()
            formIsValid = false;
        }

        if (formDataError?.image) {
            combinedRef.current['image'].focus()
            formIsValid = false;
        }
        if (formDataError?.player_image) {
            combinedRef.current['player_image'].focus()
            formIsValid = false;
        }
        if (formDataError?.tv_image) {
            combinedRef.current['tv_image'].focus()
            formIsValid = false;
        }
        if (formData?.banner && !formData?.episode_trailer?.length && defaultOption?.trailer?.length) {
            combinedRef.current['episode_trailer'].focus()
            formIsValid = false;
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                episode_trailer: "Please select trailer.",
            }));
        }

        if (formData?.banner === 1) {
            if (!sliderImageFile && (!formData?.Slider_Thumbnail || formData?.Slider_Thumbnail === "" || formData?.Slider_Thumbnail?.includes('default_vertical_image.webp') || formData?.Slider_Thumbnail?.includes('uploads/settings/'))) {
                setFormDataError((prev) => ({
                    ...prev,
                    slider_image: "Please upload a slider image."
                }));
                combinedRef.current['slider_image']?.focus();
                formIsValid = false;
            }
        }

        if (!formData?.selected_categories?.length) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                selected_categories: "Category cannot be empty.",
            }));
            formIsValid = false;
        }
        if (formData?.access == "ppv") {
            if (globalPpvStatusActive?.PPV_Individual_Contents == 1 && !formData?.ppv_price && !formData?.ios_ppv_price) {
                setPriceModel(true)
            }
            if (!formData?.ppv_price) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    ppv_price: "PPV price cannot be empty.",
                }));
                combinedRef.current['ppv_price'].focus()
                formIsValid = false;
            }
            if (!formData?.ios_ppv_price) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    ios_ppv_price: "IOS price cannot be empty.",
                }));
                combinedRef.current['ios_ppv_price'].focus()
                formIsValid = false;
            }
        }
        if (imagerequiredValidation?.series === 1) {
            if (((id && (formData?.image_url?.includes('default_vertical_image.webp') || formData?.image_url?.includes('uploads/settings/'))) || (!id && !coverImageFile)) && !coverImageFile) {
                setFormDataError(prev => ({
                    ...prev,
                    image: "Please upload a cover image."
                }));
                combinedRef.current['image'].focus();
                formIsValid = false;
            }
            if (((id && (formData?.player_image_url?.includes('default_horizontal_image.webp') || formData?.player_image_url?.includes('uploads/settings/'))) || (!id && !playerImageFile)) && !playerImageFile) {
                setFormDataError((prev) => ({
                    ...prev,
                    "player_image": "Please upload a player image."

                }))
                combinedRef.current['player_image'].focus()
                formIsValid = false;
            }
            if (((id && (formData?.tv_image_url?.includes('default_horizontal_image.webp') || formData?.tv_image_url?.includes('uploads/settings/'))) || (!id && !tvImageFile)) && !tvImageFile) {
                setFormDataError((prev) => ({
                    ...prev,
                    "tv_image": "Please upload a tv image."
                }))
                combinedRef.current['tv_image'].focus()
                formIsValid = false;
            }
        }
        if (formData?.website_URL) {
            const urlPattern = /^https?:\/\/(?:[-\w.])+(?::[0-9]+)?(?:\/[^?\s]*)?(?:\?[^#\s]*)?(?:#[^\s]*)?$/i;
            if (!urlPattern.test(formData.website_URL)) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    website_URL: "Please enter a valid URL format starting with http:// or https://",
                }));
                combinedRef.current['website_URL'].focus()
                formIsValid = false;
            }
        }
        if (!formData?.title || formData?.title.trim().length < 3 || formData?.title.trim().length > 100) {
            toast.error("Title must be between 3 and 100 characters.");
            formIsValid = false;
        }

        // if (!formData?.slug || formData?.slug.trim().length < 3 || formData?.slug.trim().length > 100) {
        //     toast.error("Slug must be between 3 and 100 characters.");
        //     formIsValid = false;
        // }

        return formIsValid;
    }

    const handleStore = (e) => {
        if (formValidation()) {
            if (!id) {
                handleAdd()
            }
            else {
                handleUpdate()
            }
        }

    }
    const handleFileUpload = async (id, name) => {
        try {
            const formDataAdd = new FormData();
            const imageFields = [];
            if (name === 'video-image') {
                if (coverImageFile) {
                    formDataAdd.append('image', coverImageFile);
                    imageFields.push('image');
                }
                if (playerImageFile) {
                    formDataAdd.append('player_image', playerImageFile);
                    imageFields.push('player_image');
                }
                if (tvImageFile) {
                    formDataAdd.append('tv_image', tvImageFile);
                    imageFields.push('tv_image');
                }
                if (notificationImageFile) {
                    formDataAdd.append('push_notification_image', notificationImageFile);
                    imageFields.push('push_notification_image');
                }
                if (sliderImageFile) {
                    formDataAdd.append('slider_image', sliderImageFile);
                    imageFields.push('slider_image');
                }

                formDataAdd.append('id', id)
                formDataAdd.append('modelName', 'Series');

                imageFields.forEach((field) => { formDataAdd.append('imageFields[]', field) });


                const response = await fetchRequest({
                    method: 'POST',
                    url: `${imageApi}`,
                    params: {},
                    data: formDataAdd,
                })
            }
            if (name == 'series-image') {
                formDataAdd.append('image', seasonImageFile)
                formDataAdd.append('modelName', 'SeriesSeason');
                formDataAdd.append('imageFields[]', 'image')
                formDataAdd.append('id', id)
                const response = await fetchRequest({
                    method: 'POST',
                    url: `${imageApi}`,
                    params: {},
                    data: formDataAdd,
                })
                if (response?.data?.status) {
                    // toast.success(response?.data?.message)
                }
            }
            setCoverImageFile(null)
            setPlayerImageFile(null)
            setTvImageFile(null)
            setSeasonImageFile(null)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        }
    }

    const formValidationSeason = () => {
        let formIsValid = true;
        if (!seasonData?.title) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                season_title: "Season title cannot be empty.",
            }));
            combinedRef.current['season_title'].focus()
            formIsValid = false;
        }
        if (!seasonData?.access) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                season_access: "Choose season the access.",
            }));
            combinedRef.current['season_access'].focus()
            formIsValid = false;
        }
        const parentSeriesIsPPV = formData?.access === "ppv" || formData?.access === "PPV";
        if (seasonData?.access == "ppv" && !parentSeriesIsPPV) {
            if (globalPpvStatusActive?.PPV_Individual_Contents == 1 && !seasonData?.ppv_price && !seasonData?.ios_ppv_price) {
                setSeasonPriceModel(true)
            }
            if (!seasonData?.ppv_price) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    season_ppv_price: "PPV price cannot be empty.",
                }));
                combinedRef.current['season_ppv_price'].focus()
                formIsValid = false;
            }
            if (!seasonData?.ios_ppv_price) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    season_ios_ppv_price: "IOS price cannot be empty.",
                }));
                combinedRef.current['season_ios_ppv_price'].focus()
                formIsValid = false;
            }
        }
        if (imagerequiredValidation?.season === 1) {
            if ((seasonData?.series_id && (seasonData?.image?.includes('default_vertical_image.webp') || seasonData?.image?.includes('uploads/settings/'))) || (!seasonData?.series_id && !seasonImageFile)) {
                setFormDataError((prev) => ({
                    ...prev,
                    "season_image": "Please provide season image"
                }))
                combinedRef.current['season_image'].focus()
                formIsValid = false;
            }
        }
        return formIsValid
    }
    const handleStoreSeason = async () => {
        if (formValidationSeason()) {
            setSeasonData((prev) => ({ ...prev, loading: true }))
            if (seasonData?.series_id) {
                const response = await fetchRequest({
                    method: 'POST',
                    url: `${seasonUpdate}/${seasonData?.id}`,
                    params: {},
                    data: { ...seasonData }
                });
                if (response?.status) {
                    // strict save custom field values for season update
                    try {
                        await saveCustomFieldsStrict({ baseURL, headers, entityType: 'season', entityId: seasonData?.id, values: customFieldValuesSeason });
                    } catch (e) {
                        toast.error(e.message || 'Failed to save additional fields');
                        setSeasonData((prev) => ({ ...prev, loading: false }));
                        return;
                    }
                    if (seasonImageFile) {
                        await handleFileUpload(response?.id, 'series-image')
                    }
                    if (seasonData?.individualPPVTrigger == "done") {
                        await handleSeasonPPVPriceStore(response?.id)
                    }
                    if (response?.message) {
                        toast.success(response.message);
                    }
                    setWithOutRefreshSeason((prev) => !prev)
                    handleseasonModal()
                    setSeasonData((prev) => ({ series_id: "", loading: false }))
                }
            }
            else {
                const response = await fetchRequest({
                    method: 'POST',
                    url: `${seasonStore}`,
                    params: {},
                    data: {
                        ...seasonData,
                        series_id: formData?.id,
                    }
                });
                if (response?.status) {
                    // save custom field values (season - strict)
                    try {
                        await saveCustomFieldsStrict({ baseURL, headers, entityType: 'season', entityId: response?.id || seasonData?.id, values: customFieldValuesSeason });
                    } catch (e) {
                        toast.error(e.message || 'Failed to save additional fields');
                        setSeasonData((prev) => ({ ...prev, loading: false }));
                        return;
                    }
                    if (seasonImageFile) {
                        await handleFileUpload(response?.id, 'series-image')
                    }
                    if (seasonData?.individualPPVTrigger == "done") {
                        await handleSeasonPPVPriceStore(response?.id)
                    }
                    if (response?.message) {
                        toast.success(response.message);
                    }
                    setWithOutRefreshSeason((prev) => !prev)
                    setSeasonPriceModel(false)
                    setSeasonModal(false)
                    setSeasonData((prev) => ({ series_id: "", loading: false }))
                }
                else {
                    setSeasonData((prev) => ({ series_id: "", loading: false }))
                }
            }
        }
    }

    const handleAdd = async () => {
        setShowOverlay(true);
        try {
            let finalData = {
                ...formData,
                category_id: formData?.selected_categories || [],
                artist_id: formData?.selected_artists?.map((item) => item?.value) || [],
                languages_id: formData?.selected_Languages?.map((item) => item?.value) || [],
                regions_id: formData?.selected_Regions?.map((item) => item?.value) || [],
                block_country_id: formData?.selected_blocked_country?.map((item) => item?.value) || [],
                search_tag: formData?.search_tag,
                push_notification_enabled: formData?.push_notification_enabled || 0,
                push_notification_title: formData?.push_notification_title,
                push_notification_description: formData?.push_notification_description,
                push_notification_publish_type: formData?.push_notification_publish_type || 'publish_now',
                push_notification_publish_time: formData?.push_notification_publish_time,
                push_notification_source_type: formData?.push_notification_source_type || 3,
                push_notification_source_type_name: formData?.push_notification_source_type_name || "Series",
                push_notification_slug: formData?.push_notification_slug,
            }

            // Remove File objects to prevent serialization errors in JSON payload
            const imageFields = ['image', 'player_image', 'tv_image', 'slider_image'];
            imageFields.forEach(field => {
                if (finalData[field] instanceof File) {
                    delete finalData[field];
                }
            });

            const response = await fetchRequest({
                method: 'POST',
                url: `${storeApi}`,
                params: {},
                data: finalData
            });
            if (response?.status) {
                // save custom field values (strict)
                try {
                    await saveCustomFieldsStrict({ baseURL, headers, entityType: 'series', entityId: response?.id, values: customFieldValues });
                } catch (e) {
                    toast.error(e.message || 'Failed to save additional fields');
                    setShowOverlay(false);
                    return;
                }
                if (coverImageFile || playerImageFile || tvImageFile || notificationImageFile || sliderImageFile) {
                    console.log("coevrImageFile", coverImageFile);
                    await handleFileUpload(response?.id, 'video-image')
                }
                if (formData?.website_URL || formData?.website_page_title || formData?.Meta_description) {
                    const responses = await fetchRequest({
                        method: 'POST',
                        url: `${seoApi}`,
                        params: {},
                        data: {
                            id: response?.id,
                            website_page_title: formData?.website_page_title,
                            website_URL: formData?.website_URL,
                            Meta_description: formData?.Meta_description
                        }
                    });
                }
                if (response?.id) {
                    if (formData?.individualPPVTrigger == "done") {
                        await handlePPVPriceStore(response?.id || id)
                    }
                }
                navigate(`/edit-series/${response?.id}`)
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message || error?.message || "Something went wrong")
        }
        finally {
            setShowOverlay(false)
        }

    }
    const handleUpdate = async () => {
        setShowOverlay(true);
        try {
            let finalData = {
                ...formData,
                category_id: formData?.selected_categories || [],
                artist_id: formData?.selected_artists?.map((item) => item?.value) || [],
                languages_id: formData?.selected_Languages?.map((item) => item?.value) || [],
                regions_id: formData?.selected_Regions?.map((item) => item?.value) || [],
                available_countries_id: formData?.selected_available_country?.map((item) => item?.value) || [],
                block_country_id: formData?.selected_blocked_country?.map((item) => item?.value) || [],
                search_tag: formData?.search_tag,
                episode_trailer: (formData?.episode_trailer || []).filter(item => item != "").join(","),
                push_notification_enabled: formData?.push_notification_enabled || 0,
                push_notification_title: formData?.push_notification_title,
                push_notification_description: formData?.push_notification_description,
                push_notification_publish_type: formData?.push_notification_publish_type || 'publish_now',
                push_notification_publish_time: formData?.push_notification_publish_time,
                push_notification_source_type: formData?.push_notification_source_type || 3,
                push_notification_source_type_name: formData?.push_notification_source_type_name || "Series",
                push_notification_slug: formData?.push_notification_slug,

            }

            // Remove File objects to prevent serialization errors in JSON payload
            const imageFields = ['image', 'player_image', 'tv_image', 'slider_image'];
            imageFields.forEach(field => {
                if (finalData[field] instanceof File) {
                    delete finalData[field];
                }
            });

            const response = await fetchRequest({
                method: 'POST',
                url: `${updateApi}/${id}`,
                params: {},
                data: finalData
            });
            if (response?.status) {
                // save custom field values (strict)
                try {
                    await saveCustomFieldsStrict({ baseURL, headers, entityType: 'series', entityId: id, values: customFieldValues });
                } catch (e) {
                    toast.error(e.message || 'Failed to save additional fields');
                    setShowOverlay(false);
                    return;
                }
                if (coverImageFile || playerImageFile || tvImageFile || notificationImageFile || sliderImageFile) {
                    await handleFileUpload(response?.id, 'video-image')
                }
                if (formData?.website_URL || formData?.website_page_title || formData?.Meta_description) {
                    const responses = await fetchRequest({
                        method: 'POST',
                        url: `${seoApi}`,
                        params: {},
                        data: {
                            id: response?.id,
                            website_page_title: formData?.website_page_title,
                            website_URL: formData?.website_URL,
                            Meta_description: formData?.Meta_description
                        }
                    });
                }
                if (response?.id) {
                    await handlePPVPriceStore(response?.id || id)
                }
                setWithOutRefresh((prev) => !prev)
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message || error?.message || "Something went wrong")
        }
        finally {
            setShowOverlay(false)
        }
    }
    const labelFetch = async () => {
        try {
            const response = await axios.get(`${labelApi}`, { headers: headers });
            const result = response?.data?.label_management
            setLabelDisplay(result)
        }
        catch (err) {
            toast.error(err?.response?.data?.message)
        }
        finally {
            setLoading(false)
        }
    }
    const fetchCreateData = async () => {
        setLoading(true)
        try {
            const response = await fetchRequest({
                method: 'GET',
                url: `${createApi}`,
                params: {},
                data: {}
            });

            const result = response;
            const defaultoptionslist = {
                artistsOption: multiSelectLabel(result?.artists, 'id', 'artist_name'),
                categoryOption: result?.series_category || [],
                languageOption: multiSelectLabel(result?.languages, 'id', 'name'),
                regionOption: multiSelectLabel(result?.regions, 'id', 'name'),
                blockCountryOption: multiSelectLabel(result?.block_country, 'id', 'country_name'),
                availableCountryOption: multiSelectLabel(result?.available_country, 'id', 'country_name'),
                accessOption: result?.user_access,
                iosOption: result?.inapppurchase,
                globalOption: result?.ppv_gobal_price ? result?.ppv_gobal_price : '',
                defaultCurrency: result?.DefaultCurrency?.[0],
                // Ideabiz PPV purchase plans (create API)
                ideabizPPVPurchase: result?.ideabizPPVPurchase || [],
                googleProductIdPPV: result?.googleProductIdPPV || [],
            }
            setDefaultOption(defaultoptionslist);
            setGetGeoFencing(result?.getGeofencing);
            setGetGeoFencingAvailableCountries(result?.getGeofencingAvailableCountries);
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message)
        }
        finally {
            setLoading(false)
        }
    };
    const fetchEditData = async () => {
        setLoading(true)
        try {
            const response = await axios.get(`${editApi}/${id}`, { headers: headers });
            const result = response?.data;
            const previousFormData = result?.data;
            const updatedFormData = {
                ...previousFormData,
                selected_artists: multiSelectLabel(previousFormData?.selected_artists, 'id', 'name'),
                selected_categories: (previousFormData?.selected_categories || []).map(c => Number(c.id)),
                selected_Languages: multiSelectLabel(previousFormData?.selected_Languages, 'id', 'name'),
                selected_Regions: multiSelectLabel(previousFormData?.selected_Regions, 'id', 'name'),
                selected_blocked_country: multiSelectLabel(previousFormData?.selected_blocked_country, 'id', 'name'),
                selected_available_country: multiSelectLabel(previousFormData?.selected_available_country, 'id', 'name'),
                selected_playlist_videos: multiSelectLabel(previousFormData?.selected_playlist_videos, 'id', 'name'),
                selected_related_videos: multiSelectLabel(previousFormData?.selected_related_videos, 'id', 'name'),
                publisher_musician: multiSelectLabel(previousFormData?.publisher_musician, 'id', 'name'),
                publisher_songwriter: multiSelectLabel(previousFormData?.publisher_songwriter, 'artist_id', 'name'),
                search_tag: previousFormData?.search_tag?.split(",")?.map((tag) => tag?.trim()),
                ppv_status: assignDefault(previousFormData.ppv_status),
                // carry over Ideabiz purchase plan if present
                ideabiz_purchase_plans_id: previousFormData?.ideabiz_purchase_plans_id || null,
                google_product_id_ppvs_id: previousFormData?.google_product_id_ppvs_id || null,
                album_id: assignDefault(previousFormData.album_id),
                rating: assignDefault(previousFormData.rating),
                active: previousFormData?.status == 0 ? 1 : assignDefault(previousFormData?.active),
                draft: assignDefault(previousFormData.draft),
                featured: assignDefault(previousFormData.featured),
                banner: assignDefault(previousFormData.banner),
                Slider_Thumbnail: previousFormData.Slider_Thumbnail || "",
                views: assignDefault(previousFormData.views),
                year: previousFormData.year,
                episode_trailer: previousFormData?.episode_trailer?.split(",").filter(item => item != "").map((item) => Number(item)),
                globalOption: result?.ppv_gobal_price ? result?.ppv_gobal_price : '',
                publish_type: previousFormData.publish_type ? previousFormData.publish_type : 'publish_now',
                push_notification_enabled: assignDefault(previousFormData?.push_notification_enabled),
                push_notification_title: previousFormData?.push_notification_title || "",
                push_notification_description: previousFormData?.push_notification_description || "",
                push_notification_image: previousFormData?.push_notification_image || "",
                push_notification_image_url: previousFormData?.push_notification_image_url || "",
                push_notification_publish_type: previousFormData?.push_notification_publish_type || "publish_now",
                push_notification_publish_time: previousFormData?.push_notification_publish_time ? previousFormData.push_notification_publish_time.replace(' ', 'T').slice(0, 16) : "",
                ssai_vmap_url: previousFormData?.ssai_vmap_url || "",
                is_shorts: assignDefault(previousFormData?.is_shorts),
            };
            setFormData((prev) => ({ ...prev, ...updatedFormData, response_status: result?.status, response_status_code: result?.status, response_loading: false }))


            // Default DropDown List

            const defaultoptionslist = {
                artistsOption: multiSelectLabel(result.artists, 'id', 'artist_name'),
                categoryOption: result?.series_category || [],
                languageOption: multiSelectLabel(result.languages, 'id', 'name'),
                regionOption: multiSelectLabel(result.regions, 'id', 'name'),
                blockCountryOption: multiSelectLabel(result.block_country, 'id', 'name'),
                availableCountryOption: multiSelectLabel(result.available_country, 'id', 'name'),
                accessOption: result.user_access,
                iosOption: result?.inapppurchase,
                globalOption: result.ppv_gobal_price ? result.ppv_gobal_price : '',
                defaultCurrency: result?.DefaultCurrency,
                trailer: result?.episodeActiveTrailer,
                // Ideabiz PPV purchase plans (edit API)
                ideabizPPVPurchase: result?.ideabizPPVPurchase || [],
                googleProductIdPPV: result?.googleProductIdPPV || [],
            }

            if (!defaultoptionslist.googleProductIdPPV || defaultoptionslist.googleProductIdPPV.length === 0) {
                try {
                    const createResponse = await axios.get(`${createApi}`, { headers: headers });
                    if (createResponse?.data?.googleProductIdPPV?.length) {
                        defaultoptionslist.googleProductIdPPV = createResponse.data.googleProductIdPPV;
                    }
                } catch (error) {
                    console.error("Error fetching fallback googleProductIdPPV:", error);
                }
            }
            setConvertPrice(prevState => {
                return {
                    ...prevState,
                    source_type: 3,
                    source_id: id,
                    PPVType: formData?.global_ppv,
                    PriceType: result?.DefaultCurrency?.code,
                    ActualPrice: result?.ppv_price,
                    IOSPrice: result?.ios_ppv_price,
                    convertedPriceRates: [...result?.ContentPriceRates]
                };
            });
            setDefaultOption((prev) => ({ ...prev, ...defaultoptionslist }));
            toast.success(response?.data?.message)
        } catch (error) {
            if (error?.response?.status == 404 || error?.response?.status == 500) {
                setFormData((prev) => ({ ...prev, error: error.response.data.message || "ID not found or api something went wrong." }))
            }
        }
        finally {
            setLoading(false)
        }
    };
    const handleEditSeason = async (seasonId) => {
        try {
            const response = await fetchRequest({
                method: 'GET',
                url: `${seasonEditApi}/${seasonId}`,
                params: {},
                data: {},
            })
            if (response?.status) {
                setSeasonData({ status: response?.status, loading: false, ...response?.data })
                setSeasonConvertPrice(prevState => {
                    return {
                        ...prevState,
                        PPVType: seasonData?.global_ppv,
                        PriceType: response?.DefaultCurrency?.code,
                        ActualPrice: response?.data?.ppv_price,
                        IOSPrice: response?.data?.ios_ppv_price,
                        convertedPriceRates: [...response?.data?.ContentPriceRates]
                    };
                });
                // toast.success(response?.message)
                setSeasonModal(true)
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message)
            setSeasonData({ status: false, loading: false, data: "", error: error?.response?.data?.message })
        }
    }
    const fetchSeason = async (seriesId) => {
        try {
            const response = await fetchRequest({
                method: 'GET',
                url: `${SeriesSeasonFind}/${seriesId}`,
                params: {},
                data: {},
            })
            if (response?.status) {
                setSeason({ status: response?.status, loading: false, data: response })
                // toast.success(response?.message)
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message)
            setSeason({ status: false, loading: false, data: "", error: error?.response?.data?.message })
        }

    }
    const handlePPVPriceStore = async (sourceID) => {
        setShowOverlay(true);
        try {
            const payload = {
                ...convertPrice,
                source_id: sourceID,
                ideabiz_purchase_plans_id: formData?.ideabiz_purchase_plans_id || null,
                google_product_id_ppvs_id: formData?.google_product_id_ppvs_id || null,
                push_notification_enabled: formData?.push_notification_enabled || 0,
                push_notification_title: formData?.push_notification_title,
                push_notification_description: formData?.push_notification_description,
                push_notification_publish_type: formData?.push_notification_publish_type || 'publish_now',
                push_notification_publish_time: formData?.push_notification_publish_time,
            };
            const response = await axios.post(`${updatePPV}`, payload, { headers: headers });
            const result = response?.data
            if (result?.status) {
                setShowOverlay(false);
                setPriceModel(false)
            }
            else {
                setShowOverlay(false);
                toast.error(result?.message)
            }
        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
    }
    const handleSeasonPPVPriceStore = async (sourceID) => {
        setShowOverlay(true);
        try {
            // Send season PPV conversion data along with season-level Ideabiz plan ID (raw ID)
            const payload = {
                ...seasonConvertPrice,
                source_id: sourceID,
                ideabiz_purchase_plans_id: seasonData?.ideabiz_purchase_plans_id || null,
                google_product_id_ppvs_id: seasonData?.google_product_id_ppvs_id || null,
            };

            const response = await axios.post(`${seasonUpdatePPV}`, payload, { headers: headers });
            const result = response?.data
            if (result?.status) {
                setShowOverlay(false);
                setPriceModel(false)
            }
            else {
                setShowOverlay(false);
                toast.error(result?.message)
            }
        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
    }
    const handlePriceChangeInput = (e, index) => {
        const { value } = e.target;
        setConvertPrice(prevState => {
            const updatedRates = [...prevState.convertedPriceRates];
            updatedRates[index] = {
                ...updatedRates[index],
                ConvertedPriceRate: value
            };
            return {
                ...prevState,
                convertedPriceRates: updatedRates
            };
        });
    };

    const handleDragEnd = (result) => {
        if (!result.destination) return;
        const reorderedItems = Array.from(season?.data?.SeriesSeason || []);
        const [movedItem] = reorderedItems?.splice(result.source.index, 1);
        reorderedItems?.splice(result.destination.index, 0, movedItem);
        setSeason((prev) => ({
            ...prev,
            data: {
                ...prev.data,
                SeriesSeason: reorderedItems
            }
        }));
        saveShuffleOrder(reorderedItems);
    };

    const saveShuffleOrder = async (updatedItems) => {
        setShowOverlay(true);

        if (!updatedItems || updatedItems?.length === 0) {
            toast.error("Menu items are empty");
            return;
        }
        else {
            const ids = updatedItems?.map((menuItem) => menuItem?.id);
            const positions = updatedItems?.map((_, index) => index + 1);
            const requestData = {
                id: ids,
                position: positions,
            };
            try {
                const response = await axios.post(`${seasonOrderApi}`, requestData, { headers: headers });
                const result = response?.data;
                if (result?.status) {
                    toast.success(result?.message)
                    setWithOutRefresh(!withOutRefresh)
                    setShowOverlay(false);
                }
                else {
                    setShowOverlay(false)
                    toast.error(result?.message)
                }
            } catch (err) {
                setShowOverlay(false)
                console.error(err);
                var errorMessage = err?.response?.data?.message;
                toast.error(errorMessage)
            }
        }
    };
    const handleSeasonDeleteModelOpen = (seasonDetails) => {
        setModelClose(true)
        setItemToDelete(seasonDetails)
    }
    const handleSeasonDelete = async () => {
        const response = await fetchRequest({
            method: 'DELETE',
            url: `${seasonDeleteApi}`,
            params: {},
            data: {
                id: [itemToDelete?.id]
            }
        });
        if (response?.status) {
            if (response?.message) {
                toast.success(response?.message);
            }
            setModelClose(false)
            setItemToDelete({})
            setWithOutRefreshSeason((prev) => !prev)
        }
        else {
            toast.error(response?.data?.message)
        }
    }


    // dom loaded

    useEffect(() => {
        labelFetch()
    }, [])
    useEffect(async () => {
        if (!id) {
            await fetchCreateData()
        }
    }, [])

    useEffect(() => {
        if (id) {
            fetchEditData()
        }
    }, [withOutRefresh, id])
    useEffect(async () => {
        if (id) {
            await fetchSeason(id)
        }
    }, [withOutRefreshSeason, id])

    useEffect(() => {
        if (seasonModal || pricemodel || seasonPriceModel || languageModal || artistModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [seasonModal, pricemodel, seasonPriceModel, languageModal, artistModal, categoryModal]);

    if (loading) {
        return <Defaultloadinggif className={`heightOnLoader`} />
    }
    if (id && formData?.response_loading) {
        return <Defaultloadinggif className={`heightOnLoader`} />
    }
    if (id && !formData?.response_status && !formData?.response_loading) {
        return <AdminResponseZone response={formData} />
    }

    // Find index of current access level from formData
    const currentAccessIndex = defaultOption?.accessOption?.findIndex(
        (item) => item.role === formData?.access
    );

    // Filter options based on current access level
    const filteredAccessOptions = defaultOption?.accessOption?.filter((item) => {
        const itemIndex = defaultOption?.accessOption?.findIndex(
            (accItem) => accItem.role === item?.role
        );
        return itemIndex >= currentAccessIndex; // Show same or higher access levels
    });


    const confirmToggle = (suggestedText) => {
        if (suggestedText && typeof suggestedText === 'string' && modalTarget) {
            setFormData(prev => ({ ...prev, [modalTarget]: suggestedText }));
        }
        setShowModal(false);
        setModalTarget(null);
    };

    const handleModal = (target) => {
        setModalTarget(target);
        if (target === "description") {
            setDefaultPrompt(`Give a short description about "${formData?.title || ""}"`);
        } else if (target === "details") {
            setDefaultPrompt(`Expand the content details for "${formData?.title || ""}"`);
        }
        setShowModal(true);
    };

    const generateSuggestion = async (promptText, setSuggestion, setLoading) => {
        const trimmedPrompt = promptText?.trim();
        setLoading(true);
        try {
            const response = await axios.post(
                generateAISuggestionApi,
                { prompt: trimmedPrompt },
                { headers }
            );
            if (response.data?.status) {
                setLoading(false);
                setSuggestion(response.data.response);
            } else {
                alert(response.data.message || "Failed to generate suggestion.");
            }
        } catch (error) {
            if (error.response?.status === 401) {
                alert("Token expired or invalid. Please login again.");
            } else {
                console.error(error);
                alert("Error generating suggestion.");
            }
        }
    };

    const TreeCheckboxSeries = ({ node, selectedIds, onToggle, depth = 0 }) => {
        const isChecked = (selectedIds || []).includes(Number(node.id));
        const hasChildren = Array.isArray(node.sub_category) && node.sub_category.length > 0;
        return (
            <div style={{ paddingLeft: depth * 18 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', padding: '4px 0' }}>
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => onToggle(Number(node.id))}
                        style={{ accentColor: 'var(--primary-color, #6366f1)', width: 15, height: 15 }}
                    />
                    <span className="theme-text-color" style={{ fontSize: 14 }}>{node.name}</span>
                </label>
                {hasChildren && node.sub_category.map(child => (
                    <TreeCheckboxSeries key={child.id} node={child} selectedIds={selectedIds} onToggle={onToggle} depth={depth + 1} />
                ))}
            </div>
        );
    };

    const CategoryMultiSelectSeries = ({ options, selectedIds, onChange, error }) => {
        const [open, setOpen] = useState(false);
        const handleToggle = (id) => {
            const updated = (selectedIds || []).includes(id)
                ? selectedIds.filter(s => s !== id)
                : [...(selectedIds || []), id];
            onChange(updated);
        };
        const collectNames = (nodes) => (nodes || []).flatMap(n => [
            ...((selectedIds || []).includes(Number(n.id)) ? [n.name] : []),
            ...collectNames(n.sub_category || [])
        ]);
        const selectedNames = collectNames(options).join(', ') || 'Select categories';
        return (
            <div className="position-relative mb-3">
                <div
                    id="series-category-multiselect-toggle"
                    onClick={() => setOpen(o => !o)}
                    className="custom-input custom-input-border w-100 d-flex align-items-center justify-content-between"
                    style={{ cursor: 'pointer', minHeight: 42, padding: '6px 12px' }}
                >
                    <span style={{ color: (selectedIds || []).length ? 'inherit' : '#888', fontSize: 14 }}>{selectedNames}</span>
                    <span style={{ fontSize: 11 }}>&#9660;</span>
                </div>
                {open && (
                    <div
                        id="series-category-multiselect-dropdown"
                        className="theme-bg-color"
                        style={{ position: 'absolute', zIndex: 999, top: '100%', left: 0, right: 0, maxHeight: 260, overflowY: 'auto', border: '1px solid rgba(128,128,128,0.3)', borderRadius: 6, padding: '8px 12px', boxShadow: '0 4px 12px rgba(0,0,0,0.2)' }}
                    >
                        {(options || []).length === 0 && <p className="theme-text-color opacity-50" style={{ fontSize: 13 }}>No categories found</p>}
                        {(options || []).map(node => (
                            <TreeCheckboxSeries key={node.id} node={node} selectedIds={selectedIds} onToggle={handleToggle} />
                        ))}
                    </div>
                )}
                {error && <div className="errorred mt-1" style={{ fontSize: 13 }}>{error}</div>}
            </div>
        );
    };

    return (
        <div className='mb-5'>
            {showOverlay && (<Response_Processing />)}
            <AdminBackNavigation path={`/series-list`} text='Back' />

            {languageModal && (
                <div class={`modal packageModel fade ${languageModal && 'd-block show'}`} id="seriesLanguageModal" tabIndex="-1" role="dialog" aria-labelledby="seriesLanguageModalLabel" >
                    <div className="modal-dialog modal-large" role="document">
                        <div className="modal-content theme-bg-color ">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Add Language" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button type="button" className='bg-transparent theme-text-color' onClick={() => setLanguageModal(false)} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                            </div>
                            <div className="modal-body">
                                <LanguageAddUpdate isModal={true} forceCreate={true} onSuccess={(newId, newName) => {
                                    if (newId && newName) {
                                        setDefaultOption(prev => ({
                                            ...prev,
                                            languageOption: [...(prev?.languageOption || []), { value: newId, label: newName }]
                                        }));
                                        setFormData(prev => {
                                            const curr = Array.isArray(prev?.selected_Languages) ? prev.selected_Languages : [];
                                            return { ...prev, selected_Languages: [...curr, { value: newId, label: newName }] };
                                        });
                                    }
                                    setLanguageModal(false);
                                }} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {categoryModal && (
                <div class={`modal packageModel fade ${categoryModal && 'd-block show'}`} id="seriesCategoryModal" tabIndex="-1" role="dialog" aria-labelledby="seriesCategoryModalLabel" >
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content theme-bg-color ">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Manage Series Categories" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button type="button" className='bg-transparent theme-text-color' onClick={() => setCategoryModal(false)} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                            </div>
                            <div className="modal-body">
                                <SeriesGenreAddUpdate isModal={true} forceCreate={true} onSuccess={(newId, newName) => {
                                    if (newId && newName) {
                                        setDefaultOption(prev => ({
                                            ...prev,
                                            categoryOption: [...(prev?.categoryOption || []), { id: newId, name: newName, sub_category: [] }]
                                        }));
                                        setFormData(prev => {
                                            const curr = Array.isArray(prev?.selected_categories) ? prev.selected_categories : [];
                                            return { ...prev, selected_categories: [...curr, Number(newId)] };
                                        });
                                    }
                                    setCategoryModal(false);
                                }} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {artistModal && (
                <div class={`modal packageModel fade ${artistModal && 'd-block show'}`} id="seriesArtistModal" tabIndex="-1" role="dialog" aria-labelledby="seriesArtistModalLabel" >
                    <div className="modal-dialog modal-large" role="document">
                        <div className="modal-content theme-bg-color ">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Add Artist" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button type="button" className='bg-transparent theme-text-color' onClick={() => setArtistModal(false)} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                            </div>
                            <div className="modal-body">
                                <ArtistAddUpdate isModal={true} forceCreate={true} onSuccess={(newId, newName) => {
                                    if (newId && newName) {
                                        setDefaultOption(prev => ({
                                            ...prev,
                                            artistsOption: [...(prev?.artistsOption || []), { value: newId, label: newName }]
                                        }));
                                        setFormData(prev => {
                                            const curr = Array.isArray(prev?.selected_artists) ? prev.selected_artists : [];
                                            return { ...prev, selected_artists: [...curr, { value: newId, label: newName }] };
                                        });
                                    }
                                    setArtistModal(false);
                                }} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div class={`modal  packageModel fade ${pricemodel && 'd-block show'}`} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" >
                <div className="modal-dialog modal-large" role="document">
                    <div className="modal-content  theme-bg-color ">
                        <div className="modal-header  theme-border-bottom-secondary">
                            <MessageBox text="Price exchange" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                            <button id="ppvCloseModelUp" type="button" className='bg-transparent theme-text-color' onClick={handlePriceModalClose} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                        </div>
                        <div className="modal-body">
                            {/* <div className="d-flex justify-content-between mb-2 col-8 me-auto">
                                    <div className="col-12 col-md-6 pe-2">
                                        <MessageSubHeading text={labelDisplay?.[34]?.sub_title} />
                                    </div>
                                    <div className="col-12 col-md-6 ps-2 text-end">
                                        <AdminSwitch id="globalPPVCheckbox" name={'global_ppv'} checked={formData?.global_ppv == 1} onChange={handleInput} />
                                    </div>
                                </div> */}

                            <div className="row mx-0 align-items-start mb-3 ">
                                <div className="col-12 col-md-5 ps-0 ">
                                    <MessageLabel text={`${formData?.global_ppv == 0 ? labelDisplay?.[34]?.title : labelDisplay?.[36]?.title}  (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                                    <AdminCustomInput isReadonly={formData?.global_ppv == 1} type="number" id="countryPPVPrice" name="ppv_price" value={formData?.ppv_price} onChange={handleInput} placeHolder={"Please enter ppv price"} ref={(el) => (combinedRef.current.ppv_price = el)} error={formDataError?.ppv_price} />
                                </div>
                                <div className="col-12 col-md-5 ">
                                    <MessageLabel text={`${labelDisplay?.[35]?.title}  (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                                    <AdminCustomSelect id="countryPPVIOSPrice" name="ios_ppv_price" value={formData?.ios_ppv_price || 0} onChange={handleInput} ref={(el) => (combinedRef.current.ios_ppv_price = el)} options={defaultOption?.iosOption?.map((item) => ({ name: item?.plan_price, value: item?.id }))} error={formDataError?.ios_ppv_price} defaultOptionName={"Choose an ios price"} />
                                </div>
                                {/* Ideabiz Purchase Plan - only when data is present */}
                                {Array.isArray(defaultOption?.ideabizPPVPurchase) && defaultOption.ideabizPPVPurchase.length > 0 && (
                                    <div className="col-12 col-md-5 mt-3 ps-0 ">
                                        <MessageLabel text="Idea Biz Purchase" />
                                        <AdminCustomSelect
                                            id="series-ideabiz-purchase-plans"
                                            name="ideabiz_purchase_plans_id"
                                            // Now storing only the raw ID for ideabiz_purchase_plans_id
                                            value={formData?.ideabiz_purchase_plans_id || ''}
                                            onChange={(e) => {
                                                const planId = e.target.value;
                                                setFormData(prev => ({
                                                    ...prev,
                                                    ideabiz_purchase_plans_id: planId ? parseInt(planId) : null,
                                                }));
                                            }}
                                            options={defaultOption.ideabizPPVPurchase.map(plan => ({
                                                name: plan?.plan_name || plan?.name || `Plan ${plan?.id}`,
                                                value: plan?.id,
                                            }))}
                                            defaultOptionName="Choose Idea Biz plan"
                                        />
                                    </div>
                                )}
                                {Array.isArray(defaultOption?.googleProductIdPPV) && defaultOption.googleProductIdPPV.length > 0 && (
                                    <div className="col-12 col-md-5 mt-3 ps-0 ">
                                        <MessageLabel text="Google Purchase" />
                                        <AdminCustomSelect
                                            id="series-google-product-ppvs"
                                            name="google_product_id_ppvs_id"
                                            value={formData?.google_product_id_ppvs_id || ''}
                                            onChange={(e) => {
                                                const planId = e.target.value;
                                                setFormData(prev => ({
                                                    ...prev,
                                                    google_product_id_ppvs_id: planId ? parseInt(planId) : null,
                                                }));
                                            }}
                                            options={defaultOption.googleProductIdPPV.map(plan => ({
                                                name: plan?.product_id || plan?.name || `Product ${plan?.id}`,
                                                value: plan?.id,
                                            }))}
                                            defaultOptionName="Choose Google Purchase"
                                        />
                                    </div>
                                )}
                                <div className="col-12 col-md-2 pe-0 align-self-center mt-4">
                                    <AdminCustomButton id="covertPriceButton" className='px-3 py-1 m-0' saveMethod={() => handleCovertPrice(formData?.ppv_price)} saveText='Convert' />
                                </div>
                            </div>
                            <div className="priceTable rounded-3  ">
                                <table class="table rounded-3  position-relative">
                                    <thead className="theme-bg-color-secondary  z-index-1">
                                        <tr>
                                            <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Country</th>
                                            <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Current Price</th>
                                            <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Converted Price</th>
                                            {/* <th scope="col">Converted IOS Price</th> */}
                                            <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Difference</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {convertPrice?.convertedPriceRates?.length ? convertPrice?.convertedPriceRates.map((item, index) => (
                                            <tr key={index}>
                                                <td className="" scope="row">{`${item?.Country} (${item?.Code})`}</td>
                                                <td className="">{item.Symbol} {item?.price || item?.ActualPrice}</td>
                                                <td className=""> <AdminCustomInput id="priceChangeInput" isReadonly={formData?.global_ppv == 1} type="text" name="price" value={item?.ConvertedPriceRate} onChange={(e) => handlePriceChangeInput(e, index)} placeHolder={"Fill the custom price"} noMargin noBorder={formData?.global_ppv == 1} className={`${formData?.global_ppv == 1 && 'border-0'}`} /> </td>
                                                <td className="">{item?.RateDifference}</td>
                                            </tr>
                                        )) :
                                            <tr>
                                                <td colSpan={4} className="errorred text-center">* Please update the pricing according to the specific market in each currency !.</td>
                                            </tr>}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer  border-0">
                            <button id="ppvCloseModelDown" type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={handlePriceModalClose} ><MessageBox text="Cancel" /> </button>
                            <AdminCustomButton id="series-ppv-proceed-button" className='px-3 py-1 m-0 ' saveMethod={() => handlePriceModalClose("done")} saveText='Done' />
                        </div>
                    </div>
                </div>
            </div>

            <div class={`modal  packageModel fade ${seasonPriceModel && 'd-block show'}`} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" >
                <div className="modal-dialog modal-large" role="document">
                    <div className="modal-content  theme-bg-color ">
                        <div className="modal-header  theme-border-bottom-secondary">
                            <MessageBox text="Price exchange" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                            <button id="ppvCloseModelUp" type="button" className='bg-transparent theme-text-color' onClick={handleSeasonPriceModalClose} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                        </div>
                        <div className="modal-body">
                            {/* <div className="d-flex justify-content-between mb-2 col-8 me-auto">
                                    <div className="col-12 col-md-6 pe-2">
                                        <MessageSubHeading text={labelDisplay?.[34]?.sub_title} />
                                    </div>
                                    <div className="col-12 col-md-6 ps-2 text-end">
                                        <AdminSwitch id="globalPPVCheckbox" name={'global_ppv'} checked={formData?.global_ppv == 1} onChange={handleInput} />
                                    </div>
                                </div> */}

                            <div className="row mx-0 align-items-start mb-3 ">
                                <div className="col-12 col-md-5 ps-0 ">
                                    <MessageLabel text={`${labelDisplay?.[34]?.title}  (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                                    <AdminCustomInput type="number" id="countryPPVPrice" name="ppv_price" value={seasonData?.ppv_price} onChange={handleSeasonInput} placeHolder={"Please enter ppv price"} ref={(el) => (combinedRef.current.season_ppv_price = el)} error={formDataError?.season_ppv_price} />
                                </div>
                                <div className="col-12 col-md-5 ">
                                    <MessageLabel text={`${labelDisplay?.[35]?.title}  (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                                    <AdminCustomSelect id="countryPPVIOSPrice" name="ios_ppv_price" value={seasonData?.ios_ppv_price || 0} onChange={handleSeasonInput} ref={(el) => (combinedRef.current.season_ios_ppv_price = el)} options={defaultOption?.iosOption?.map((item) => ({ name: item?.plan_price, value: item?.id }))} error={formDataError?.season_ios_ppv_price} defaultOptionName={"Choose an ios price"} />
                                </div>
                                {/* Season-level Ideabiz Purchase Plan - only when data is present */}
                                {Array.isArray(defaultOption?.ideabizPPVPurchase) && defaultOption.ideabizPPVPurchase.length > 0 && (
                                    <div className="col-12 col-md-5 mt-3 ps-0 ">
                                        <MessageLabel text="Idea Biz Purchase" />
                                        <AdminCustomSelect
                                            id="season-ideabiz-purchase-plans"
                                            name="ideabiz_purchase_plans_id"
                                            // Season modal also stores only the raw ID for Ideabiz plan
                                            value={seasonData?.ideabiz_purchase_plans_id || ''}
                                            onChange={(e) => {
                                                const planId = e.target.value;
                                                setSeasonData(prev => ({
                                                    ...prev,
                                                    ideabiz_purchase_plans_id: planId ? parseInt(planId) : null,
                                                }));
                                            }}
                                            options={defaultOption.ideabizPPVPurchase.map(plan => ({
                                                name: plan?.plan_name || plan?.name || `Plan ${plan?.id}`,
                                                value: plan?.id,
                                            }))}
                                            defaultOptionName="Choose Idea Biz plan"
                                        />
                                    </div>
                                )}
                                {Array.isArray(defaultOption?.googleProductIdPPV) && defaultOption.googleProductIdPPV.length > 0 && (
                                    <div className="col-12 col-md-5 mt-3 ps-0 ">
                                        <MessageLabel text="Google Purchase" />
                                        <AdminCustomSelect
                                            id="season-google-product-ppvs"
                                            name="google_product_id_ppvs_id"
                                            value={seasonData?.google_product_id_ppvs_id || ''}
                                            onChange={(e) => {
                                                const planId = e.target.value;
                                                setSeasonData(prev => ({
                                                    ...prev,
                                                    google_product_id_ppvs_id: planId ? parseInt(planId) : null,
                                                }));
                                            }}
                                            options={defaultOption.googleProductIdPPV.map(plan => ({
                                                name: plan?.product_id || plan?.name || `Product ${plan?.id}`,
                                                value: plan?.id,
                                            }))}
                                            defaultOptionName="Choose Google Purchase"
                                        />
                                    </div>
                                )}
                                <div className="col-12 col-md-2 pe-0 align-self-center mt-4">
                                    <AdminCustomButton id="covertPriceButton" className='px-3 py-1 m-0' saveMethod={() => handleSeasonCovertPrice(seasonData?.ppv_price)} saveText='Convert' />
                                </div>
                            </div>
                            <div className="priceTable rounded-3  ">
                                <table class="table rounded-3  position-relative">
                                    <thead className="theme-bg-color-secondary  z-index-1">
                                        <tr>
                                            <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Country</th>
                                            <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Current Price</th>
                                            <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Converted Price</th>
                                            {/* <th scope="col">Converted IOS Price</th> */}
                                            <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Difference</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {seasonConvertPrice?.convertedPriceRates?.length ? seasonConvertPrice?.convertedPriceRates.map((item, index) => (
                                            <tr key={index}>
                                                <td className="" scope="row">{`${item?.Country} (${item?.Code})`}</td>
                                                <td className="">{item.Symbol} {item?.price || item?.ActualPrice}</td>
                                                <td className=""> <AdminCustomInput id="priceChangeInput" isReadonly={seasonData?.global_ppv == 1} type="text" name="price" value={item?.ConvertedPriceRate} onChange={(e) => handlePriceChangeInput(e, index)} placeHolder={"Fill the custom price"} noMargin noBorder={seasonData?.global_ppv == 1} className={`${seasonData?.global_ppv == 1 && 'border-0'}`} /> </td>
                                                <td className="">{item?.RateDifference}</td>
                                            </tr>
                                        )) :
                                            <tr>
                                                <td colSpan={4} className="errorred text-center">* Please update the pricing according to the specific market in each currency !.</td>
                                            </tr>}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer  border-0">
                            <button id="ppvCloseModelDown" type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={handleSeasonPriceModalClose} ><MessageBox text="Cancel" /> </button>
                            <AdminCustomButton id="season-ppv-proceed-button" className='px-3 py-1 m-0 ' saveMethod={() => handleSeasonPriceModalClose("done")} saveText='Done' />
                        </div>
                    </div>
                </div>
            </div>
            {seasonModal && <div class={`modal  season packageModel fade ${seasonModal && 'd-block show'}`} id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content  theme-bg-color">
                        <div className="modal-header theme-border-bottom-secondary">
                            <MessageBox text={seasonData?.series_id ? labelDisplay?.[50]?.sub_title : labelDisplay?.[44]?.title} classname="modal-title theme-text-color admin-modal-title fw-bold" />
                            <button type="button" id="handleSeasonModal" className='bg-transparent theme-text-color' onClick={() => handleseasonModal()} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                        </div>
                        <div className="modal-body postion-relative model-height">
                            <MessageLabel text={labelDisplay?.[45]?.title} className="mandatorySimple" />
                            <MessageSubHeading text={labelDisplay?.[45]?.sub_title} />
                            <AdminCustomInput id="edit-series-tile-modal" type="text" name="title" value={seasonData?.title} ref={(el) => (combinedRef.current.season_title = el)} onChange={handleSeasonInput} placeHolder={"Please enter season title"} error={formDataError?.season_title} />
                            <MessageLabel text={labelDisplay?.[46]?.title} className={`${imagerequiredValidation?.season === 1 ? 'mandatorySimple' : ""}`} />
                            <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[46]?.sub_title, 'landscape')} />
                            <AdminImageUploadZone
                                idAttribute="edit-series-fileInputRef4"
                                onChange={handleFileChange}
                                selectedFile={seasonImageFile}
                                uploadedImage={seasonData?.image_url}
                                onDelete={handleClearSelectFile}
                                ref={(el) => (combinedRef.current.season_image = el)}
                                name="season_image"
                                orientationSlug="landscape"
                                id={id}
                                error={formDataError?.season_image}
                            />

                            <div className="card p-3 mt-3">
                                {/* <MessageHeading text="Additional Fields" /> */}
                                {/* Custom fields */}
                                <FieldRenderer2
                                    pageIdentifier={seasonData?.series_id ? "seasons.edit" : "seasons.create"}
                                    entityType="season"
                                    entityId={seasonData?.id}
                                    text="Additional Fields"
                                />
                                <FieldRenderer
                                    pageIdentifier={seasonData?.series_id ? "seasons.edit" : "seasons.create"}
                                    entityType="season"
                                    entityId={seasonData?.id}
                                    onChange={setCustomFieldValuesSeason}
                                />
                            </div>
                            <MessageLabel text={labelDisplay?.[22]?.title} className="mandatorySimple" />
                            <MessageSubHeading text={labelDisplay?.[22]?.sub_title} />
                            {/* <AdminCustomSelect id="season-access" name="access" value={seasonData?.access} onChange={handleSeasonInput} ref={(el) => (combinedRef.current.season_access = el)} options={defaultOption?.accessOption?.map((item) => ({ name: item?.name, value: item?.role }))} error={formDataError?.season_access} defaultOptionName={"Choose an user access"} />*/}
                            <AdminCustomSelect
                                id="season-access"
                                name="access"
                                value={seasonData?.access}
                                onChange={handleSeasonInput}
                                ref={(el) => (combinedRef.current.season_access = el)}
                                options={filteredAccessOptions?.map((item) => ({
                                    name: item?.name,
                                    value: item?.role,
                                }))}
                                error={formDataError?.season_access}
                                defaultOptionName="Choose an user access"
                            />


                            {seasonData?.access === "ppv" && formData?.access !== "ppv" && <>
                                {globalPpvStatusActive?.PPV_Individual_Contents == 0 ?
                                    (
                                        <div className="mt-3">
                                            <MessageLabel text={labelDisplay?.[34]?.title} />
                                            {/* <div className="d-flex justify-content-between mb-2 ">
                                                <div className="col-6 col-md-6 pe-2">
                                                    <MessageSubHeading text={labelDisplay?.[34]?.sub_title} />
                                                </div>
                                                <div className="col-6 col-md-6 ps-2 text-end">
                                                    <AdminSwitch id="series-ppv-price" name={'global_ppv'} checked={formData?.global_ppv == 1} onChange={handleInput} />
                                                </div>
                                            </div> */}
                                            <AdminCustomInput id="series-ppv-price2" isReadonly={formData?.global_ppv == 1} type="text" name="ppv_price" value={formData?.ppv_price} onChange={handleInput} placeHolder={"Please enter ppv price"} ref={(el) => (combinedRef.current.ppv_price = el)} error={formDataError?.ppv_price} />
                                            <MessageLabel text={labelDisplay?.[35]?.title} />
                                            <MessageSubHeading text={labelDisplay?.[35]?.sub_title} />
                                            <AdminCustomSelect id="series-ios-ppv-price" name="ios_ppv_price" value={formData?.ios_ppv_price || 0} onChange={handleInput} ref={(el) => (combinedRef.current.ios_ppv_price = el)} options={defaultOption?.iosOption?.map((item) => ({ name: item?.plan_price, value: item?.id }))} error={formDataError?.ios_ppv_price} defaultOptionName={"Choose an ios price"} />
                                        </div>
                                    )
                                    :
                                    <div className="mt-3">
                                        <AdminCustomButton id="series-custom-ppv-button" saveMethod={() => handleSeasonPriceModal()} saveText="Customize PPV" className="d-block ms-auto mt-3" />
                                    </div >
                                }
                            </>}
                        </div>
                        <div className="modal-footer  border-0 ">
                            <button type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={() => handleseasonModal(0)} id="closeModal"><MessageBox text="Cancel" /> </button>
                            <AdminCustomButton className='px-3 py-1 m-0 ' saveMethod={() => handleStoreSeason()} saveText={seasonData?.series_id ? labelDisplay?.[50]?.sub_title : labelDisplay?.[44]?.sub_title} loading={seasonData?.loading}></AdminCustomButton>
                        </div>
                    </div>
                </div>
            </div>}
            {modelClose && <AdminDeleteModal modelClose={modelClose} deleteClose={closeModal} deleteAction={handleSeasonDelete} buttonText={'custom'} message={`Are you sure you want to delete this season?`} />}
            <AdminSaveHeader buttonId="seriesFormSubmitButtonUp" heading={!id ? labelDisplay?.[0]?.title : labelDisplay?.[33]?.title} saveText={!id ? labelDisplay?.[1]?.title : labelDisplay?.[32]?.title} loading={showOverlay} saveMethod={handleStore} />
            <FormContainer className="pb-5">
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={!id ? labelDisplay?.[1]?.title : labelDisplay?.[32]?.title} />
                        <MessageLabel text={labelDisplay?.[2]?.title} className="mandatorySimple" />
                        <MessageSubHeading text={labelDisplay?.[2]?.sub_title} />
                        <AdminCustomInput id="series-title" type="text" name="title" value={formData?.title} onChange={handleInput} placeHolder={"Title"} ref={(el) => (combinedRef.current.title = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.title} />

                        <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
                        <MessageSubHeading text={labelDisplay?.[3]?.sub_title} />
                        <AdminCustomInput id="series-slug" type="text" name="slug" value={formData?.slug} onChange={handleInput} placeHolder={"Slug"} ref={(el) => (combinedRef.current.slug = el)} onBlur={handleBlurTitleEdit} error={formDataError?.slug} />

                        {showModal && (<AdminAIModal modalDescription="Suggest AI" modalHeading="Generate Content" modelClose={showModal} sliderClose={closeAIModal} applySuggestion={confirmToggle} generateSuggestion={generateSuggestion} defaultPrompt={defaultPrompt} />)}
                        <MessageLabel text={labelDisplay?.[4]?.title} enableAI handleAIModal={() => handleModal("description")} />
                        <MessageSubHeading text={labelDisplay?.[4]?.sub_title} />
                        <AdminCustomArea id="series-description" name="description" value={formData?.description} onChange={handleInput} placeHolder={"Description"} ref={(el) => (combinedRef.current.description = el)} error={formDataError?.description} rows={5} />

                        <MessageLabel text={labelDisplay?.[5]?.title} enableAI handleAIModal={() => handleModal("details")} />
                        <MessageSubHeading text={labelDisplay?.[5]?.sub_title} />
                        <JoditEditor className="series-editor mb-3" ref={(el) => (combinedRef.current.details = el)} value={formData?.details} onChange={(newContent) => setFormData(prev => ({ ...prev, details: newContent }))} />

                        {customFieldValues?.length > 0 && (
                            <div className="card p-3 mt-3">
                                <MessageHeading text="Additional Fields" />
                                {/* Custom fields */}
                                <FieldRenderer2
                                    pageIdentifier={id ? "series.edit" : "series.create"}
                                    entityType="series"
                                    entityId={id}
                                    onChange={setCustomFieldValues}
                                />
                            </div>
                        )}

                        <MessageLabel text={labelDisplay?.[7]?.title} />
                        <MessageSubHeading text={labelDisplay?.[7]?.sub_title} />
                        <AdminCustomSelect id="series-custom-select" name="year" value={formData?.year} onChange={handleInput} ref={(el) => (combinedRef.current.year = el)} options={years} error={formDataError?.year} defaultOptionName="Choose video release year" />
                    </Wrapper>
                    <Wrapper>

                        <MessageHeading text={labelDisplay?.[8]?.title} />

                        <div className="d-flex justify-content-between align-items-start">
                            <div className="pe-2">
                                <MessageLabel text={labelDisplay?.[11]?.title} className="mandatorySimple" />
                                <MessageSubHeading text={labelDisplay?.[11]?.sub_title} />
                            </div>
                            <button type="button" id="series-category-add-button" className="vjs-big-play-button rounded" onClick={() => setCategoryModal(true)} title="Add Category">
                                < MdAddCircle style={{ width: "20px", height: "20px" }} />
                            </button>
                        </div>
                        <CategoryMultiSelectSeries
                            options={defaultOption?.categoryOption || []}
                            selectedIds={formData?.selected_categories || []}
                            onChange={(ids) => {
                                setFormData(prev => ({ ...prev, selected_categories: ids }));
                                setFormDataError(prev => ({ ...prev, selected_categories: '' }));
                            }}
                            error={formDataError?.selected_categories}
                        />

                        <div className="d-flex justify-content-between align-items-start">
                            <div className="pe-2">
                                <MessageLabel text={labelDisplay?.[12]?.title} />
                                <MessageSubHeading text={labelDisplay?.[12]?.sub_title} />
                            </div>
                            <button type="button" id="series-language-add-button" className="vjs-big-play-button rounded" onClick={() => setLanguageModal(true)} title="Add Language">
                                < MdAddCircle style={{ width: "20px", height: "20px" }} />
                            </button>
                        </div>
                        <Select id="series-select-language" options={defaultOption?.languageOption} isMulti name={'selected_Languages'} onChange={handleMultiSelect} value={formData?.selected_Languages} className="custom-select-multi custom-placeholder theme-text-color mb-3" />

                        {onlyPermission?.includes(47) && (
                            <>
                                <MessageLabel text={"Region"} />
                                <MessageSubHeading text={"Add Region for the Series below"} />
                                <Select id="series-select-region" options={defaultOption?.regionOption} isMulti name={'selected_Regions'} onChange={handleMultiSelect} value={formData?.selected_Regions} className="custom-select-multi custom-placeholder theme-text-color mb-3" />
                            </>
                        )}

                        <div className="d-flex justify-content-between align-items-start">
                            <div className="pe-2">
                                <MessageLabel text={labelDisplay?.[10]?.title} />
                                <MessageSubHeading text={labelDisplay?.[10]?.sub_title} />
                            </div>
                            <button type="button" id="series-artist-add-button" className="vjs-big-play-button rounded" onClick={() => setArtistModal(true)} title="Add Artist">
                                < MdAddCircle style={{ width: "20px", height: "20px" }} />
                            </button>
                        </div>
                        <Select id="series-select-artist" options={defaultOption?.artistsOption} isMulti name={'selected_artists'} onChange={handleMultiSelect} value={formData?.selected_artists} className="custom-select-multi custom-placeholder theme-text-color mb-3" />

                        <MessageLabel text={labelDisplay?.[9]?.title} />
                        <MessageSubHeading text={labelDisplay?.[9]?.sub_title} />
                        <AdminCustomSelect id="series-rating" name="rating" value={formData?.rating} onChange={handleInput} ref={(el) => (combinedRef.current.rating = el)} options={Array.from({ length: 10 })?.map((item, index) => ({ name: index + 1, value: index + 1 }))} error={formDataError?.rating} defaultOptionName={"Choose an rating"} />

                    </Wrapper>
                    {(getGeofencing === "ON" || getGeofencingAvailableCountries === 1) && (
                        <Wrapper>
                            <MessageHeading text={labelDisplay?.[54]?.title} />

                            {getGeofencing === "ON" && (
                                <>
                                    <MessageLabel text={labelDisplay?.[13]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[13]?.sub_title} />
                                    <Select id="series-select-block-country" options={defaultOption?.blockCountryOption?.filter((blockedItem) => !formData?.selected_available_country?.some((availableItem) => availableItem?.value === blockedItem?.value))} isMulti name={"selected_blocked_country"} onChange={handleMultiSelect} value={formData?.selected_blocked_country} className="custom-select-multi custom-placeholder theme-text-color mb-3" />
                                </>)}
                            {getGeofencingAvailableCountries === 1 && (
                                <>
                                    <MessageLabel text={labelDisplay?.[14]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[14]?.sub_title} />
                                    <Select id="series-select-available-country" options={defaultOption?.availableCountryOption?.filter((AvailableItem) => !formData?.selected_blocked_country?.some((blockedItem) => blockedItem?.value === AvailableItem?.value))} isMulti name={`selected_available_country`} onChange={handleMultiSelect} value={formData?.selected_available_country} className="custom-select-multi custom-placeholder theme-text-color mb-3" />
                                </>)}
                        </Wrapper>
                    )}

                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[15]?.title} />
                        <MessageLabel text={labelDisplay?.[16]?.title} className="" />
                        <MessageSubHeading text={labelDisplay?.[16]?.sub_title} />
                        <TagsInput id="series-search-tags" name="search_tag" value={formData?.search_tag} separators={["Enter", ","]} classNames={{ tag: "series-search-tags custom-search-tag", input: "w-100" }} onChange={handleTagsChange} />
                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[17]?.title} />
                        <MessageLabel text={labelDisplay?.[18]?.title} className={`${imagerequiredValidation?.series === 1 ? 'mandatorySimple' : ""}`} />
                        <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[18]?.sub_title, 'portrait')} />
                        <AdminImageUploadZone
                            idAttribute="series-image-url"
                            onChange={handleFileChange}
                            selectedFile={coverImageFile}
                            uploadedImage={formData?.image_url}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.image = el)}
                            name="image"
                            orientationSlug="portrait"
                            id={id}
                            error={formDataError?.image}
                        />
                        <MessageLabel text={labelDisplay?.[19]?.title} className={`${imagerequiredValidation?.series === 1 ? 'mandatorySimple' : ""}`} />
                        <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[19]?.sub_title, 'landscape')} />
                        <AdminImageUploadZone
                            idAttribute="series-player-image-url"
                            onChange={handleFileChange}
                            selectedFile={playerImageFile}
                            uploadedImage={formData?.player_image_url}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.player_image = el)}
                            name="player_image"
                            orientationSlug="landscape"
                            id={id}
                            error={formDataError?.player_image}
                        />
                        <MessageLabel text={labelDisplay?.[20]?.title} className={`${imagerequiredValidation?.series === 1 ? 'mandatorySimple' : ""}`} />
                        <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[20]?.sub_title, 'landscape')} />
                        <AdminImageUploadZone
                            idAttribute="series-image-upload-selectfile2"
                            onChange={handleFileChange}
                            selectedFile={tvImageFile}
                            uploadedImage={formData?.tv_image_url}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.tv_image = el)}
                            name="tv_image"
                            orientationSlug="landscape"
                            error={formDataError?.tv_image}
                            id={id}
                        />
                    </Wrapper>
                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[21]?.title} />
                        <MessageLabel text={labelDisplay?.[22]?.title} className="mandatorySimple" />
                        <MessageSubHeading text={labelDisplay?.[22]?.sub_title} />
                        <AdminCustomSelect id="series-user-access" name="access" value={formData?.access} onChange={handleInput} ref={(el) => (combinedRef.current.access = el)} options={defaultOption?.accessOption?.map((item) => ({ name: item?.name, value: item?.role }))} error={formDataError?.access} defaultOptionName={"Choose an user access"} />
                        {formData?.access === "ppv" && <>
                            {globalPpvStatusActive?.PPV_Individual_Contents == 0 ?
                                (
                                    <div className="mt-3">
                                        <MessageLabel text={labelDisplay?.[34]?.title} />
                                        <AdminCustomInput id="series-ppv-price2" isReadonly={formData?.global_ppv == 1} type="text" name="ppv_price" value={formData?.ppv_price} onChange={handleInput} placeHolder={"Please enter ppv price"} ref={(el) => (combinedRef.current.ppv_price = el)} error={formDataError?.ppv_price} />
                                        <MessageLabel text={labelDisplay?.[35]?.title} />
                                        <MessageSubHeading text={labelDisplay?.[35]?.sub_title} />
                                        <AdminCustomSelect id="series-ios-ppv-price" name="ios_ppv_price" value={formData?.ios_ppv_price || 0} onChange={handleInput} ref={(el) => (combinedRef.current.ios_ppv_price = el)} options={defaultOption?.iosOption?.map((item) => ({ name: item?.plan_price, value: item?.id }))} error={formDataError?.ios_ppv_price} defaultOptionName={"Choose an ios price"} />
                                    </div>
                                )
                                :
                                <div className="mt-3">
                                    <AdminCustomButton id="series-custom-ppv-button" saveMethod={() => handlePriceModal()} saveText="Customize PPV" className="d-block ms-auto mt-3" />
                                </div >
                            }
                        </>}
                    </Wrapper>
                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[23]?.title} />
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={labelDisplay?.[24]?.title} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch id="series-select-featured" name={'featured'} checked={formData?.featured === 1} onChange={handleInput} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={labelDisplay?.[25]?.title} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch id="series-select-active" name={'active'} checked={formData?.active === 1} onChange={handleInput} />
                            </div>
                        </div>
                        {(onlyPermission?.includes(48)) && (
                            <div className="d-flex justify-content-between mb-2 ">
                                <div className="col-6 col-md-6 pe-2">
                                    <MessageLabel text={"Promote as Advertisement"} />
                                </div>
                                <div className="col-6 col-md-6 ps-2 text-end">
                                    <AdminSwitch id="series-select-is-ads" name={'is_ads'} checked={formData?.is_ads === 1} onChange={handleInput} />
                                </div>
                            </div>
                        )}

                        {(onlyPermission?.includes(49)) && (
                            <div className="d-flex justify-content-between mb-2 ">
                                <div className="col-6 col-md-6 pe-2">
                                    <MessageLabel text={"Enable as Shorts"} />
                                </div>
                                <div className="col-6 col-md-6 ps-2 text-end">
                                    <AdminSwitch id="series-is-shorts" name={'is_shorts'} checked={formData?.is_shorts === 1} onChange={handleInput} />
                                </div>
                            </div>
                        )}
                        {formDataError?.episode_trailer && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.episode_trailer}`} classname='errorred  d-block' /></div>)}
                        {id && defaultOption?.trailer?.length > 0 && formData?.banner === 1 && (
                            <>
                                <div className='d-flex align-items-center flex-wrap'>
                                    {defaultOption?.trailer?.map((item, index) => {

                                        let checked = formData?.episode_trailer?.includes(item?.id);
                                        return (
                                            <div key={item?.id} className='rounded-3 d-flex align-items-center gap-3 w-100 theme-bg-color p-2 mb-2'  >
                                                <AdminCheckBox id={"episodeTrailer"} onChange={() => handleTrailerSelect(item?.id)} checked={checked} />
                                                <div className="d-flex align-items-center gap-2">
                                                    <img
                                                        src={item?.image_url}
                                                        className='rounded-1 trailer-episode-image'
                                                        alt={item?.title}
                                                    />
                                                    <p className='mt-2 mb-0'>{item?.title}</p>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </>
                        )}

                        <div className="mt-3">
                            <MessageLabel text="Custom SSAI VMAP URL" />
                            <AdminCustomInput type="text" name="ssai_vmap_url" value={formData?.ssai_vmap_url} onChange={handleInput} placeHolder={"https://example.com/vmap.xml"} />
                        </div>
                    </Wrapper>

                    <Wrapper>
                        <MessageHeading text="Slider Setting" />
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={labelDisplay?.[26]?.title || "Enable as Slider"} className={`${formData?.banner === 1 && 'mandatorySimple'}`} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch id="series-select-banner" ref={(el) => (combinedRef.current.episode_trailer = el)} name={'banner'} checked={formData?.banner === 1} onChange={handleInput} />
                            </div>
                        </div>
                        {formData?.banner === 1 && (
                            <>
                                <MessageLabel text="Slider Image" className={`${formData?.banner === 1 ? 'mandatorySimple' : ''}`} />
                                <MessageSubHeading text="Resolution 3840*1440 and Ratio 8:3" />
                                <AdminImageUploadZone
                                    idAttribute={`series-slider-image-${id}`}
                                    onChange={handleFileChange}
                                    selectedFile={sliderImageFile}
                                    uploadedImage={formData?.Slider_Thumbnail}
                                    onDelete={handleClearSelectFile}
                                    ref={(el) => (combinedRef.current.slider_image = el)}
                                    name="slider_image"
                                    apiFieldName="slider_image"
                                    error={formDataError?.slider_image}
                                    id={id}
                                />
                            </>
                        )}
                    </Wrapper>
                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[28]?.title} />

                        <MessageLabel text={labelDisplay?.[29]?.title} />
                        <AdminCustomInput id="series-website-title" name="website_page_title" value={formData?.website_page_title} ref={(el) => (combinedRef.current.website_page_title = el)} onChange={handleInput} placeHolder={"Website title"} error={formDataError?.website_page_title} />

                        <MessageLabel text={labelDisplay?.[30]?.title} />
                        <AdminCustomInput id="series-website-url" name="website_URL" value={formData?.website_URL} onChange={handleInput} placeHolder={"Website url"} ref={(el) => (combinedRef.current.website_URL = el)} error={formDataError?.website_URL} />

                        <MessageLabel text={labelDisplay?.[31]?.title} />
                        <AdminCustomArea id="series-website-meta-description" name="Meta_description" value={formData?.Meta_description || ""} onChange={handleInput} ref={(el) => (combinedRef.current.Meta_description = el)} placeHolder={"Please enter Meta description"} rows={5} />
                    </Wrapper>

                    {onlyPermission?.includes(44) &&
                        <PushNotificationSettings
                            formData={formData}
                            setFormData={setFormData}
                            handleInput={handleInput}
                            handleFileChange={handleFileChange}
                            selectedFile={notificationImageFile}
                            uploadedImage={formData?.push_notification_image_url}
                            onDelete={handleClearSelectFile}
                            combinedRef={combinedRef}
                            formDataError={formDataError}
                            siteTheme={siteTheme}
                            id={id}
                            onlyPermission={onlyPermission}
                            sourceTitle={formData?.title}
                            sourceDescription={formData?.description}
                            sourceType={3}
                            sourceTypeName="Series"
                            slug={formData?.slug}
                            prefix="series"
                        />
                    }
                </RightWrapper>
                <AdminCustomButton id="seriesFormSubmitButtonDown" className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={!id ? labelDisplay?.[1]?.title : labelDisplay?.[32]?.title} loading={showOverlay} />
            </FormContainer>
            {id &&
                (<div className='theme-bg-color p-3 rounded-3'>
                    <div className="d-flex align-items-center flex-wrap pb-3 ">
                        <div className="col-md-8 col-12 ">
                            <h5 className="admin-title mb-0 theme-text-color text-md-start"> <MessageBox text={labelDisplay?.[37]?.title} classname="theme-text-color" /> <span className="admin-sub-title theme-text-color ms-2 ">( {season?.data?.SeriesSeason?.length} <MessageBox text='results found' classname="theme-text-color" />   )</span> </h5>
                        </div>
                        <div className="col-md-4 col-12 d-flex align-items-center justify-content-end mt-3 mt-sm-0" >
                            <AdminCustomButton id="series-season-modal-open-button" className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleseasonModal} saveText={labelDisplay?.[38]?.title} />
                        </div>
                    </div>

                    <div className="row mt-3 theme-border-bottom-secondary pb-3">
                        <div className="col-lg-4 col-md-4 col-sm-4 col-4 p-3"> <label className="theme-text-color fw-bold fs-6"> Season </label> </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-3 p-3 "><label className="theme-text-color fw-bold fs-6">Episode Count</label></div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-3 p-3"> <label className="theme-text-color fw-bold fs-6">Actions</label></div>
                    </div>

                    <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="menu-items" className="theme-bg-color"   >
                            {(provided) => (
                                <ul  {...provided.droppableProps} ref={provided.innerRef} className="pb-5 px-0 theme-bg-color m-0 p-0 list-unstyled">
                                    {season?.loading ? <NoRecordTable result={season?.data?.SeriesSeason?.length} loader={true} /> : season?.data?.SeriesSeason?.length ?
                                        season?.data?.SeriesSeason?.map((item, index) => (
                                            <Draggable key={item?.id.toString()} draggableId={item?.id.toString()} index={index} >
                                                {(provided) => (
                                                    <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className={` theme-bg-color theme-text-color  d-flex align-items-center  ${item.order} index ${index + 1} w-100 theme-border-bottom-secondary px-3`}>
                                                        <div className="col-lg-4 col-md-4 col-sm-4 col-4 py-3">
                                                            <div className="d-flex gap-3 justify-content-start align-items-center">
                                                                <img key={item?.image_url} src={item?.image_url} alt={item?.title} className="profile theme-bg-color-secondary " />
                                                                <div className="rightVideoTitle d-flex flex-column">
                                                                    <span className='theme-text-color table-heading'>{`${item.title ? item?.title?.slice(0, 15) : ""} ...`} </span>
                                                                    <span className="dateText table-subheading theme-text-color">{item?.upload_on}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-sm-3 col-3 py-3'>
                                                            <span className='text-center d-block theme-text-color table-heading'>{item?.episode_count}</span>
                                                        </div>
                                                        <div className='col-lg-4 col-md-4 col-sm-4 col-4 py-3 d-flex aling-items-center gap-3'>
                                                            <div className="editdropdown" id="episode-action">
                                                                <span className="editdropdown-button">
                                                                    <FaEllipsisVertical className="theme-text-color" />
                                                                </span>
                                                                <div className="editdropdown-menu theme-bg-color rounded-3">
                                                                    <Link id="series-episode-navigation" to={`/manage-episode?seriesid=${id}&seasonid=${item?.id}`} className='d-flex align-items-center gap-2'><IconListFigma styled={{ width: "20px", height: "20px" }} /> <span className='text-center d-block theme-text-color table-heading'>Manage Episode</span></Link>
                                                                    <div id="series-edit-season" className='d-flex align-items-center p-3 gap-2 w-100 cursor-pointer' onClick={() => handleEditSeason(item?.id)} ><IconEditFigma styled={{ width: "20px", height: "20px" }} /><span className='text-center d-block theme-text-color table-heading'> Edit Season</span></div>
                                                                    <div id="series-delete-season" className='d-flex align-items-center p-3 gap-2 w-100 cursor-pointer' onClick={() => handleSeasonDeleteModelOpen(item)}><IconDeleteFigma styled={{ width: "20px", height: "20px" }} /><span className='text-center d-block theme-text-color table-heading'> Delete</span></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )}
                                            </Draggable>
                                        ))
                                        : <NoRecordTable result={season?.data?.SeriesSeason?.length} loader={false} />}
                                </ul>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>)
            }
        </div >
    )
}

export default SeriesAddUpdate